import React from 'react';
import {
  UnitCardProperty,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/components/UnitCardProperty';
import Box from '@mui/material/Box';
import { MarketplaceSwitch } from 'src/components/profileComponents/Marketplace/components/Common/MarketplaceSwitch';
import {
  IMarketplacePlacementCardFooterDefaultItem,
} from 'src/typings/marketplaceTile';
import { IMarketplacePlacementProperty, Option } from 'src/components/profileComponents/Marketplace/types';

interface Props {
  name: string;
  entity: IMarketplacePlacementCardFooterDefaultItem,
  onChange: (entity: IMarketplacePlacementCardFooterDefaultItem) => void;
  onSwitchChange: (checked: boolean) => void;
  lang: string;
  propertyOptions: Option<IMarketplacePlacementProperty>[]
}
export const UnitsCardFooterDefaultEntity: React.FC<Props> = ({
  name, entity, onChange, onSwitchChange, lang, propertyOptions,
}) => {
  return (
    <Box display="flex" flex="auto" gap="20px">
      <MarketplaceSwitch
        title={name}
        defaultChecked={entity.isActive}
        onChange={onSwitchChange}
      />
      <UnitCardProperty<any>
        entity={entity}
        onChange={onChange}
        lang={lang}
        propertyOptions={propertyOptions}
      />
    </Box>
  );
};
